import { asyncConfirmOverlay, openOverlay } from "overlay"
import type { Folder, Media } from "luxedo-data"
import MediaReUploadForm from "./MediaReUploadForm.svelte"
import MediaUploadForm from "./MediaUploadForm.svelte"
import NewMediaUploadForm from "./MediaUpload_Uppy.svelte"
import { userRepo } from "../../../stores/CurrentUser.svelte"

export { MediaUploadForm, MediaReUploadForm }

function openNewMediaUploadOverlay(activeFolder: Folder, postSubmit: () => void) {
	let isUploading = false

	function onComplete() {
		isUploading = false
		postSubmit()
	}

	function onStart() {
		isUploading = true
	}

	openOverlay(NewMediaUploadForm, {
		heading: "",
		classOverlay: "media-overlay no-pad",
		classHeading: "no-underline no-heading",
		hideExitButton: true,
		beforeClose: async () => {
			if (isUploading)
				await asyncConfirmOverlay({
					confirmText: "Cancel Upload",
					denyText: "Continue Upload",
					prompt: [
						"Are you sure you want to close this window?",
						"Current upload will be cancelled.",
					],
					title: "Cancel Upload",
				})
		},
		props: {
			folderId: activeFolder.id,
			userId: userRepo.user.id,
			onComplete,
			onStart,
		},
	})
}

export function openMediaUploadOverlay(
	activeFolder: Folder,
	postSubmit: () => void,
	newVersion: boolean = false,
) {
	if (newVersion) {
		openNewMediaUploadOverlay(activeFolder, postSubmit)
	} else {
		openOverlay(MediaUploadForm, {
			heading: "Select Media",
			classOverlay: "media-overlay no-pad",
			classHeading: "no-underline",
			props: {
				activeFolder: activeFolder,
				postSubmit: postSubmit,
			},
		})
	}
}

export function openMediaReUploadOverlay(media: Media) {
	openOverlay(MediaReUploadForm, {
		heading: "Reupload Media",
		classOverlay: "media-overlay no-pad",
		classHeading: "no-underline",
		props: {
			media,
		},
	})
}
